import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { SxProps, Theme } from "@mui/material";

type InputProps = {
	value: string;
	setValue: any;
	style: SxProps<Theme>;
	icon?: any;
	positionIcon: "start" | "end";
};

export default function InputComponent({
	value,
	setValue,
	style,
	positionIcon,
	icon,
}: InputProps) {
	return (
		<FormControl sx={{ width: "60%", height: "100%" }} variant="standard">
			<Input
				id="input-search"
				placeholder="Buscar"
				value={value}
				onChange={(event) => setValue(event.target.value)}
				startAdornment={
					<InputAdornment position={positionIcon}>{icon}</InputAdornment>
				}
				sx={style!}
			/>
		</FormControl>
	);
}
